import axios from "axios";
import { getLocaleLanguage } from "./i18next";
import UserController from "../Controllers/UserController";

export const backendAxios = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URI,
});

export const directsearchAxios = axios.create({
  baseURL: process.env.REACT_APP_DIRECTSEARCH_BACKEND_URI,
});

export async function initAxios() {
  const language = await getLocaleLanguage();
  backendAxios.defaults.headers.common["Accept-Language"] = language;
  directsearchAxios.defaults.headers.common["Accept-Language"] = language;

  [backendAxios, directsearchAxios].forEach((a) =>
    a.interceptors.response.use(
      (r) => r,
      (error) => {
        if (String(error?.response?.data?.message).includes("expired")) {
          UserController.logout();
        }
        return Promise.reject(error);
      },
    ),
  );
}
